import { Analytics } from '../../../services/analytics'

export const logDeleteNotes = (scope: string, success: boolean, data?: any) => {
  Analytics.logDeleteNotes({
    success,
    scope,
    data,
  })
}
